import {
    JournalClient
} from '../clients/JournalClient';
import {
    DocumentClient
} from '../clients/DocumentClient'

export const JournalModule = {
    namespaced: true,

    state: {
        showCreateFolder: false,
        folderBeingMoved: null,
        folderMoveTarget: null,
        journal: [],
        openFolders: [],
        deletingFolder: false,
        folderToDelete: null,
        movingFile: false,
        fileBeingMoved: null,
        folderBeingRenamed: null,
        fileDeleting: false,
        fileBeingDeleted: null


    },
    mutations: {
        SET_FILE_BEING_DELETED(state, payload) {
            state.fileBeingDeleted = payload
        },
        SET_FILE_DELETING(state, payload) {
            state.fileDeleting = payload
        },
        SET_FILE_BEING_MOVED(state, payload) {
            state.fileBeingMoved = payload
        },
        TOGGLE_MOVING_FILE(state, payload) {
            state.movingFile = payload
        },
        SET_FOLDER_TO_DELETE_NULL(state) {
            state.folderToDelete = null
        },
        SET_FOLDER_TO_DELETE(state, payload) {
            state.folderToDelete = payload
        },
        TOGGLE_DELETING(state, payload) {
            state.deletingFolder = payload
        },
        SET_JOURNAL(state, payload) {
            state.journal = payload
        },
        SET_CREATE_FOLDER(state, payload) {
            state.showCreateFolder = payload
        },
        SET_FOLDER_BEING_MOVED(state, payload) {
            state.folderBeingMoved = payload
        },
        SET_FOLDER_MOVE_TARGET(state, payload) {
            state.folderMoveTarget = payload
        },
        SET_FOLDER_OPEN(state, payload) {
            state.openFolders.push(payload)
        },
        SET_FOLDER_CLOSED(state, payload) {
            state.openFolders.splice(state.openFolders.indexOf(payload));
        },
        SET_ALL_FOLDERS_CLOSED(state) {
            state.openFolders = []
        },
        SET_FOLDER_BEING_RENAMED(state, payload) {
            state.folderBeingRenamed = payload
        }
    },

    actions: {
        deleteFile({
            commit,
            state,
            dispatch
        }) {
            DocumentClient.deleteDocument(state.fileBeingDeleted).then((response) => {
                commit('SET_FILE_BEING_DELETED', null)
                commit('SET_FILE_DELETING', false)
                dispatch('getJournal')
            }).catch((err) => {
                console.log(err)
            });
        },
        cancelFileDelete({
            commit
        }) {
            commit('SET_FILE_DELETING', false)
            commit('SET_FILE_BEING_DELETED', null)
        },
        startDeletingFile({
            commit
        }, payload) {
            commit('SET_FILE_DELETING', true)
            commit('SET_FILE_BEING_DELETED', payload)
        },
        startRenamingFolder({
            commit
        }, payload) {
            commit('SET_FOLDER_BEING_RENAMED', payload)
        },
        cancelRenamingFolder({
            commit
        }) {
            commit('SET_FOLDER_BEING_RENAMED', null)
        },
        renameFolder({
            commit,
            dispatch,
            state
        }, payload) {
            JournalClient.UpdateFolder(state.folderBeingRenamed, payload).then(() => {
                commit('SET_FOLDER_BEING_RENAMED', null)
                dispatch('getJournal')

            })
        },
        stopMovingFile({
            commit
        }) {
            commit('SET_FILE_BEING_MOVED', null)
            commit('TOGGLE_MOVING_FILE', false)
        },
        startMovingFile({
            commit
        }, payload) {
            commit('SET_FILE_BEING_MOVED', payload)
            commit('TOGGLE_MOVING_FILE', true)
        },
        moveFile({
            commit,
            dispatch,
            state
        }, payload) {
            JournalClient.AttachDocument(payload, state.fileBeingMoved).then(() => {
                commit('TOGGLE_MOVING_FILE', false)
                commit('SET_FILE_BEING_MOVED', null)
                dispatch('getJournal')

            })
        },
        stopDeleting({
            commit
        }) {
            commit('SET_FOLDER_TO_DELETE_NULL')
            commit('TOGGLE_DELETING', false)
        },
        startDeleting({
            commit
        }, payload) {
            commit('TOGGLE_DELETING', true)
            commit('SET_FOLDER_TO_DELETE', payload)
        },
        deleteFolder({
            commit,
            dispatch,
            state
        }) {
            JournalClient.DeleteFolder(state.folderToDelete).then(() => {
                dispatch('getJournal')
                commit('TOGGLE_DELETING', false)
                commit('SET_FOLDER_TO_DELETE_NULL')
            })
        },
        closeAllFolders({
            commit
        }) {
            commit('SET_ALL_FOLDERS_CLOSED')
        },
        toggleOpenFolder({
            commit,
            state
        }, payload) {
            if (state.openFolders.includes(payload)) {
                commit('SET_FOLDER_CLOSED', payload)
            } else {
                commit('SET_FOLDER_OPEN', payload)
            }

        },
        getJournal({
            commit
        }) {
            JournalClient.GetJournal().then((response) => {
                console.log(response);

                commit('SET_JOURNAL', response.data.journal)
            })
        },
        startNewFolder({
            commit
        }) {
            commit("SET_CREATE_FOLDER",
                true
            )
        },
        stopNewFolder({
            commit
        }) {
            commit("SET_CREATE_FOLDER",
                false
            )
        },
        createRootFolder({
            commit,
            dispatch
        }, payload) {
            JournalClient.CreateFolder(payload).then(() => {
                commit("SET_CREATE_FOLDER", false)
                dispatch('getJournal')
            })
        },
        createFolder({
            dispatch,
            commit
        }, payload) {
            JournalClient.CreateFolder(payload.FolderName).then((response) => {
                commit('SET_FOLDER_BEING_MOVED', response.data.folder.id)
                commit('SET_FOLDER_MOVE_TARGET', payload.parentFolderId)
                dispatch('moveFolder').then(() => {
                    commit('SET_CREATE_FOLDER', false)
                })
            }).catch((err) => {
                console.log(err);

            })

        },
        startMovingFolder({
            commit
        }, payload) {
            commit('SET_FOLDER_BEING_MOVED', payload)
        },
        chooseFolderTarget({
            commit
        }, payload) {
            commit('SET_FOLDER_MOVE_TARGET', payload)
        },
        cancelFolderMove({
            commit
        }) {
            commit('SET_FOLDER_BEING_MOVED', null)
            commit('SET_FOLDER_MOVE_TARGET', null)
        },
        moveFolder({
            commit,
            state,
            dispatch
        }) {

            JournalClient.MoveFolder(state.folderBeingMoved, state.folderMoveTarget).then(() => {
                commit('SET_FOLDER_BEING_MOVED', null)
                commit('SET_FOLDER_MOVE_TARGET', null)
                dispatch('getJournal')
            }).catch((err) => {
                console.log(err);
            })

        }
    }
};